module.exports = __webpack_public_path__ + "static/media/GDPR_clients.2db43acf.pdf";